import React from "react"
import { useState } from "react"
import { getMaterialIconForLevel } from "./LuiBanner"

export const LuiStaticMessage: React.FC<{
  level: "success" | "info" | "warning" | "error"
  closable?: boolean
}> = (props) => {
  const [display, setDisplay] = useState(true)
  let materialIcon = getMaterialIconForLevel(props.level)

  return display ? (
    <div className={`lui-msg-${props.level}`} data-testid={"static-message-container"}>
      <i className="lui-msg-status-icon material-icons-round">{materialIcon}</i>

      {props.children}
      {(props.closable === undefined || props.closable) && (
        <button
          aria-label="Close dialog"
          onClick={() => {
            setDisplay(false)
          }}
        >
          <i className="material-icons-round">close</i>
        </button>
      )}
    </div>
  ) : null
}
